import React, { useState } from 'react';
import ArrangementArrangerSelector from '../shared/arrangement_arranger_selector';

const getDefaultArrangerIds = (): number[] => {
  const arrangerIds = utils.getParam('arranger_ids');
  if (!arrangerIds) {
    return [];
  }
  return arrangerIds.split(',').map((id: string) => parseInt(id, 10));
};

type UseArrangerSelectorReturn = [number[], () => JSX.Element, ((ids: number[]) => void)?];

const useArrangerSelector = (): UseArrangerSelectorReturn => {
  const [arrangerIds, setArrangerIds] = useState<number[]>(getDefaultArrangerIds());

  const renderArrangerSelector = () => (
    <ArrangementArrangerSelector selectedArrangerIds={arrangerIds} onSelect={ids => setArrangerIds(ids)} />
  );

  return [arrangerIds, renderArrangerSelector, setArrangerIds];
};

export default useArrangerSelector;
